
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/request-link",
      function () {
        return require("private-next-pages/auth/request-link.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/request-link"])
      });
    }
  